<template lang="pug">
  el-container(id="UserList-container")
    el-card.el-card-margin-4.el-card-full-width.el-card-full-height-with-scroll(id="UserList-card")
      el-header(id="UserList-header" height='40px')
        span {{$t('User list')}} &nbsp; &nbsp;
        el-checkbox(v-model="displayBlocked", :title="$t('Display blocked accounts')", :label="$t('Display blocked accounts')")
        el-button.el-button--mini.float-right(
          id="UserList-addUserButton",
          :title="$t('Add new user account')",
          type='success',
          icon='el-icon-plus',
          :circle="uxParam('buttonCircle')",
          :round="uxParam('buttonRound')",
          :plain="uxParam('buttonPlain')",
          @click='handleAdd()'
        )
      .row.header
        .cell.deleted.header
          .name {{ $t('') }}
        .cell.email.header
          .name {{ $t('Email') }}
          el-input.input(id="UserList-emailSearchInput" v-model='emailSearch', size='mini', type='text', clearable)
        .cell.nick.header
          .name {{ $t('Nick') }}
          el-input.input(id="UserList-nickSearchInput" v-model='nickSearch', size='mini', type='text', clearable)
        .cell.client.header
          .name {{ $t('Client') }}
          el-input.input(id="UserList-clientSearchInput" v-model='clientNetworkSearch', size='mini', type='text', clearable)
        .cell.roles.header
          .name {{ $t('Roles') }}
          el-input.input(id="UserList-rolesSearchInput" v-model='roleSearch', size='mini', type='text', clearable)
        .cell.skin.header
          .name {{ $t('Skin') }}
          el-input.input(id="UserList-skinsSearchInput" v-model='skinSearch', size='mini', type='text', clearable)
        .cell.buttons.header {{ $t('') }}
      .row(v-for="user of users", :key='user.id', v-bind:id="'UserList-user' + user.id + 'Row'")
        .cell.deleted.danger
          font-awesome-icon(:id="'UserList-deletedUser' + user.id" v-if='user.deleted', :title='$t("Edit user")', icon="ban")
        .cell.email(:id="'UserList-emailUser'+user.id" :class='{"test-user": user.test}') {{ user.email}}
        .cell.nick(:id="'UserList-nickUser'+user.id") {{ user.nick}}
        .cell.client(:id="'UserList-clientUserCell'+user.id")
          .client-name {{ user.Client.name }}:
          .row-inner(v-for="network of user.Networks", :key='network.id')
            .network-name {{ network.name }}
        .cell.roles(:id="'UserList-rolesUser'+user.id")
          .row-inner(v-for="role of user.Roles", :key='role.id')
            .pre {{ role.name }}
        .cell.skin(:id="'UserList-skinUser'+user.id") {{ user.skin }}
        .cell.buttons
          el-button-group
            el-button(
              :id="'UserList-editUser'+user.id+'Button'"
              type="success",
              @click="handleEdit(user)",
              :title="$t('Edit user')",
              size="mini"
            )
              font-awesome-icon.float-right.button(:title='$t("Edit user")', icon="edit")
    UserEdit(:userId="editedUserId", :editDialogVisible="editDialogVisible", @closeEditDialog="handleCloseEditDialog()")
</template>

<script>
import UserEdit from './UserEdit'

export default {
  props: ['side'],
  components: {
    UserEdit
  },
  created () {
    this.$store.dispatch('User/getData')
  },
  data () {
    return {
      errors: {},
      editDialogVisible: false,
      editedUserId: undefined,
      emailSearch: '',
      nickSearch: '',
      roleSearch: '',
      clientNetworkSearch: '',
      skinSearch: '',
      displayBlocked: true
    }
  },
  methods: {
    handleAdd () {
      this.editedUserId = 0
      this.editDialogVisible = true
    },
    handleEdit (row) {
      this.editedUserId = row.id
      this.editDialogVisible = true
    },
    handleDelete (row) {
      console.log(row)
    },
    handleCloseEditDialog (result) {
      this.editedUserId = null
      this.editDialogVisible = false
    }
  },
  computed: {
    users () {
      let users = JSON.parse(JSON.stringify(this.$store.state.User.user_list))
      // filter by email
      users = this.emailSearch === '' ? users : users.filter(user => user.email.toLowerCase().indexOf(this.emailSearch.toLowerCase()) > -1)
      // filter by nick
      users = this.nickSearch === '' ? users : users.filter(user => user.nick.toLowerCase().indexOf(this.nickSearch.toLowerCase()) > -1)
      // filter by role
      users = this.roleSearch === '' ? users : users.filter(user => user.Roles.find(role => role.name.toLowerCase().indexOf(this.roleSearch.toLowerCase()) > -1))
      // filter by client or network
      users = this.clientNetworkSearch === '' ? users : users.filter((user) => {
        return user.Client.name.toLowerCase().indexOf(this.clientNetworkSearch) > -1 || user.Networks.find(net => net.name.toLowerCase().indexOf(this.clientNetworkSearch.toLowerCase()) > -1)
      })
      if (!this.displayBlocked) {
        users = users.filter(user => !user.deleted)
      }
      return users.sort((a, b) => a.nick.localeCompare(b.nick))
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../theme-m4b/src/common/var.scss";
.row {
  display: flex;
  font-size: $--font-size-base;
  padding: 10px 0px;
  &.header {
    color: $--color-text-secondary;
  }
  .cell {
    width: calc((100% - 25px - 55px)/4);
    border-bottom: $--border-light;
    // border: 1px dotted pink;
    &.email {
      &.test-user {
        color: $--color-text-regular-green;
      }
    }
    &.header {
      display: flex;
      align-items: center;
      justify-content: left;
      border-bottom: 2px solid $--color-primary;
      margin-bottom: 15px;
      padding-bottom: 15px;
      .name {
        margin-right: 15px;
      }
      .input {
        max-width: 100px;
      }
    }
    &.deleted {
      width: 25px;
    }
    &.buttons {
      text-align: right;
      width: 55px;
    }
    &.client {
      .row-inner {
        color: $--color-text-secondary;
        margin-left: 10px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/User/List.vue